import { APIError } from "src/types";

export function isAPIErrorList(error: APIError[] | Error): error is APIError[] {
  if (Array.isArray(error) && error.length > 0) {
    return isAPIError(error[0]);
  } else return false;
}

export function isAPIError(error: APIError | Error): error is APIError {
  return (
    Object.keys(error).includes("key") &&
    Object.keys(error).includes("message") &&
    Object.keys(error).includes("arguments")
  );
}

export function isError(error: APIError[] | Error): error is Error {
  return typeof error === "object" && Object.getOwnPropertyNames(error).includes("message");
}
